export const MarketingEventsDistributorsGridPluginSettings: IPluginSettings = {
    name: 'Дистрибьюторы маркетинговых мероприятий',
    mnemocode: 'marketing_events_distributors_plugin',
    permission: 'MarketingEvents',
    columns: (() => {
        let index = 0;
        return [
            {
                order: index++,
                propertyName: 'distributorName',
                propertyType: 'string',
                displayName: 'Наименование дистрибьютора',
                visibility: true,
                width: 300
            },
            {
                order: index++,
                propertyName: 'idDistributor',
                propertyType: 'number',
                displayName: 'ID дистрибьютора',
                visibility: true,
                width: 150
            },
            {
                order: index++,
                propertyName: 'priority',
                propertyType: 'number',
                displayName: 'Приоритет',
                visibility: true,
                width: 120
            },
            {
                order: index++,
                propertyName: 'usesBonus',
                propertyType: 'boolean',
                displayName: 'Использует бонус',
                visibility: true,
                width: 150
            },
            {
                order: index++,
                propertyName: 'idMarketingEventGlobal',
                propertyType: 'string',
                displayName: 'ID маркетингового мероприятия',
                visibility: false,
                width: 300
            },
            {
                order: index++,
                propertyName: 'deleted',
                propertyType: 'boolean',
                displayName: 'Удален',
                visibility: false,
                width: 100
            },
            {
                order: index++,
                propertyName: 'dateCreated',
                propertyType: 'datetime',
                displayName: 'Дата создания',
                visibility: false,
                width: 150
            },
            {
                order: index++,
                propertyName: 'dateModified',
                propertyType: 'datetime',
                displayName: 'Дата изменения',
                visibility: false,
                width: 150
            },
            {
                order: index++,
                propertyName: 'dateDeleted',
                propertyType: 'datetime',
                displayName: 'Дата удаления',
                visibility: false,
                width: 150
            },
            {
                order: index++,
                propertyName: 'idGlobal',
                propertyType: 'string',
                displayName: 'ID',
                visibility: false,
                width: 300
            }
        ];
    })()
};